var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.561 5.976a1.502 1.502 0 000-2.123L16.148 2.44a1.501 1.501 0 00-2.123 0l-1.438 1.437L16.13 7.42l1.432-1.444zm-5.68-1.391l-9.28 9.28-.591 3.357a.664.664 0 00.768.768l3.356-.588 9.278-9.28-3.532-3.537z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default ForwardRef;